import type { Product, ProductAttributeGroupOfValue, ProductVariant } from "../Product.js";

/**
 * Identifier of a product variant + attribute combination, used both as the Offer `sku`
 * in structured data and as `g:id` in the Google Merchant feed — the two must stay equal
 * for Google to match feed items with product pages. Google limits the identifier
 * to 50 characters.
 */
export function getProductVariantCombinationSku(
	product: Pick<Product, "id">,
	variant: Pick<ProductVariant, "id">,
	attributes: ProductAttributeGroupOfValue[],
): string {
	if (attributes.length === 0) {
		return `${product.id}::${variant.id}`;
	}
	// With the full product UUID (36 chars) the sku would exceed the 50 character limit
	// once attribute value ids are appended, so only its first segment is kept.
	const attributeValueIds = attributes
		.map(({ value }) => value.id)
		.sort()
		.join(":");
	return `${product.id.slice(0, 8)}::${variant.id}::${attributeValueIds}`;
}
